import { useEffect, useRef, useState } from 'react';
import FileTypeIcon from './FileTypeIcon';
import documentService from '../../services/documentService';
import { USE_MOCK } from '../../services/apiClient';
import { hasRenderedPreview } from './PagePreview';

/**
 * Grid-card thumbnail: a rendered first page or downscaled photo, requested only once the
 * card scrolls into view. Anything without a render shows the file-type icon instead.
 */
export default function Thumbnail({ item }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState(null);
  const wanted = !USE_MOCK && hasRenderedPreview(item.name);

  useEffect(() => {
    if (!wanted) return undefined;
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '240px' },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [wanted]);

  useEffect(() => {
    if (!wanted || !visible) return undefined;
    let cancelled = false;
    setUrl(null);
    documentService
      .preview(item.id, { size: 'thumb' })
      .then((result) => {
        if (!cancelled && result?.url) setUrl(result.url);
      })
      .catch(() => {
        /* the icon stays */
      });
    return () => {
      cancelled = true;
    };
  }, [wanted, visible, item.id, item.currentVersionNo]);

  return (
    <div ref={ref} className="doc-card__thumb" aria-hidden="true">
      {url ? <img src={url} alt="" loading="lazy" onError={() => setUrl(null)} /> : <FileTypeIcon name={item.name} size="lg" />}
    </div>
  );
}
